module.exports = __webpack_public_path__ + "static/media/order_icon24.02b23b3f.png";